<template>
  <div class="flex flex-col w-screen h-screen">
    <h1 class="flex justify-center text-white uppercase text-md lg:text-3xl tracking-wider">
      Teachers</h1>
    <div class="flex justify-center w-full mt-0 z-10 h-screen mb-20">
 <!-- <search-for-alph class="mr-2 w-1/2"></search-for-alph> -->
      <teacher-list class="w-full"></teacher-list>
    </div>
  </div>
</template>

<script>
import TeacherList from '../components/teachers/TeacherList.vue';
// import SearchForAlph from '../components/SearchForAlph.vue';

export default {
  components: {
    TeacherList,
  },
};
</script>
